import React from 'react';

const SentryContext = React.createContext<any>({});

export default SentryContext;
